<ui-modal
  title="Manage Product Images"
  size="lg"
  [showCloseButton]="true"
  [closeOnBackdrop]="true"
  (modalClosed)="close()">

  <div class="modal-body">
    @if (hasProductId) {
      <app-product-image-manager [productId]="productId" />
    }
  </div>

</ui-modal>

